const bundle = {
  close: () => 'סגור',
  error: () => 'שגיאה',
  warn: () => 'אזהרה',
  info: () => 'מידע',
  confirmation: () => 'אישור',
  progressIndeterminate: () => 'בתהליך',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'בין ' + p['FROM_SECTION'] + ' ו-' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. לא נמצא פרק תואם.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'לחץ על Enter כדי לבחור ערך.',
  indexer_touchInstructionText: () =>
    'הקש פעמיים והחזק כדי להיכנס למצב מחוות, ולאחר מכן גרור מעלה ומטה כדי להתאים את הערך.',
  inputPassword_show: () => 'הצג סיסמה',
  inputPassword_hide: () => 'הסתר סיסמה',
  inputPassword_hidden: () => 'סיסמה נסתרת',
  formControl_clear: () => 'מחק',
  formControl_loading: () => 'טוען',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'חריגה מהאורך המרבי ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' תווים נותרו.',
  select_noMatchesFound: () => 'לא נמצאו התאמות.',
  select_oneMatchFound: () => 'נמצאה התאמה אחת',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' התאמות נמצאו',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' או יותר התאמות נמצאו',
  selectMultiple_showSelectedValues: () => 'הצג ערכים בלבד.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' ערכים נבחרו.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'תיבת תיוג מסומנת',
  selector_unselected: () => 'תיבת תיוג לא מסומנת',
  userAssistance_learnMore: () => 'פרטים נוספים',
  userAssistance_required: () => 'דרוש',
  filePicker_singleFileUploadError: () => 'טען קובץ אחד בכל פעם',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'אי אפשר להעלות קבצים מסוג ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'אי אפשר להעלות קבצים מסוג: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'לא ידוע',
  filePicker_dropzonePrimaryText: () => 'גרור ושחרר',
  filePicker_dropzoneSecondaryText: () => 'בחר קובץ או שחרר אותו כאן',
  filePicker_dropzoneSecondaryTextMultiple: () => 'בחר קבצים או שחרר אותם כאן',
  filePicker_addFiles: () => 'הוסף קבצים',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'הגדל',
  inputNumber_decrease: () => 'הקטן',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'אין פריטים להצגה',
  message_navigationFromMessagesRegion: () =>
    'מזין אזור הודעות. לחץ על F6 כדי לנווט חזרה לרכיב שהיה קודם במוקד.',
  message_navigationToMessagesRegion: () =>
    'אזור ההודעות מכיל הודעות חדשות. לחץ על F6 כדי לנווט לאזור ההודעות האחרון.',
  messageToast_allMessagesClosed: () => 'כל ההודעות המוקפצות סגורות.'
};
export default bundle;
